import getDefaultParam from './getDefaultParam';

const getDocumentViewUrl = (id, type) =>
  `./weekly-check/${getDefaultParam('organization')}/document/${type}/${id}`;

export default getDocumentViewUrl;